var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2483 6.84018C12.2483 8.73364 10.7109 10.2686 8.81446 10.2686C6.91802 10.2686 5.38065 8.73364 5.38065 6.84018C5.38065 4.94672 6.91802 3.41176 8.81446 3.41176C10.7109 3.41176 12.2483 4.94672 12.2483 6.84018Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81785 11.6356C3.29765 11.6356 2.23779 14.3528 2.23779 15.2244C2.23779 16.0947 2.95693 16.5882 3.62871 16.5882H14.0073C14.6787 16.5882 15.398 16.0951 15.398 15.2244C15.398 14.3529 14.3379 11.6356 8.81791 11.6356H8.81785Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectPending);
export default __webpack_public_path__ + "static/media/connect-pending.5e801c5e8babca1afcbb44456bf967f0.svg";
export { ForwardRef as ReactComponent };